<div class="d-flex align-items-center justify-content-center vh-100">
    <div class="text-center">
        <h1 class="display-1 fw-bold">404</h1>
        <p class="fs-3"> <span class="text-danger">Opps!</span> Página não encontrada.</p>
        <p class="lead">
            A página que voçê está procurando não foi encontrada.
          </p>
        <!-- <a href="index.html" class="btn btn-primary">Go Home</a> -->
    </div>
</div>